import {IMetaTag} from '@core/api/data-access';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FeatureStoreNames} from '@shared-types';

import {metaTagsAdapter, MetaTagsStore} from './meta-tags.models';

import IMetaTagsState = MetaTagsStore.IMetaTagsState;
export const selectMetaTagsState = createFeatureSelector<IMetaTagsState>(FeatureStoreNames.META_TAGS_FEATURE_KEY);

export const {selectAll, selectEntities} = metaTagsAdapter.getSelectors();

export const selectMetaTagsLoaded = createSelector(selectMetaTagsState, (state: IMetaTagsState) => state.loaded);
export const selectMetaTagsLoading = createSelector(selectMetaTagsState, (state: IMetaTagsState) => state.loading);

export const selectAllMetaTags = createSelector(selectMetaTagsState, (state: IMetaTagsState) => selectAll(state));

export const selectMetaTagsEntities = createSelector(selectMetaTagsState, (state: IMetaTagsState) => selectEntities(state));

export const selectMetaTagsCount = createSelector(selectMetaTagsState, (state: IMetaTagsState) => state.ids.length);

// create selector to return meta tags dictionary with the metaTag.name as a key:
export const selectMetaTagsNamesDictionary = createSelector(selectAllMetaTags, metaTags => {
	return metaTags.reduce(
		(acc, metaTag) => {
			acc[metaTag.name] = metaTag;
			return acc;
		},
		{} as Record<string, IMetaTag>,
	);
});

export const selectEnabledMetaTags = createSelector(selectAllMetaTags, metaTags => {
	return metaTags.filter(metaTag => metaTag.isEnabled);
});

export const selectDisabledMetaTags = createSelector(selectAllMetaTags, metaTags => {
	return metaTags.filter(metaTag => !metaTag.isEnabled);
});

export const selectMetaTagByKey = (key: string) => createSelector(selectMetaTagsEntities, metaTags => metaTags[key]);

export default selectMetaTagsState;
